<template>
  <div class="examples page">
    <div class="page-wrap">
      <div class="examples-wrap">
        <div class="first steve">
          <div class="left">
            <div class="inner">
              <div class="steve-image image fadeInT"></div>
            </div>
          </div>
          <div class="right">
            <div class="inner">
              <div class="ani-wrap">
                <h1 class="fadeInB">Steveburger</h1>
              </div>
              <div class="ani-wrap">
                <p
                  class="fadeInB"
                >This demonstration site is used to simulate a local burger takeaway.</p>
              </div>
              <div class="ani-wrap">
                <p
                  class="fadeInB"
                >It's a great example of how a TouchTakeaway site with a small product range can look.</p>
              </div>
              <div class="ani-wrap">
                <p class="fadeInB">Pictures help to make ordering irresistible.</p>
              </div>
              <div class="buttons">
                <a href="http://steveburger.co.uk" target="_blank" class="fadeInB">
                  <div class="default-btn">View Site</div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="second peking">
          <div class="left">
            <div class="inner">
              <div class="steve-image image fadeInT"></div>
            </div>
          </div>
          <div class="right">
            <div class="inner">
              <div class="ani-wrap">
                <h1 class="fadeInB">Peking Panda</h1>
              </div>
              <div class="ani-wrap">
                <p class="fadeInB">This demonstration site is used to simulate a chinese takeaway.</p>
              </div>
              <div class="ani-wrap">
                <p
                  class="fadeInB"
                >Typically a chinese (or Indian) takeaway will have a large product range.</p>
              </div>
              <div class="ani-wrap">
                <p class="fadeInB">A simple list style is more fitting for this scenerio.</p>
              </div>
              <div class="buttons">
                <a href="http://pekingpanda.co.uk" target="_blank" class="fadeInB">
                  <div class="default-btn">View Site</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    example: function() {
      var x = document.querySelector("#nav");
      x.className = "";
      x.classList += "example";
    },
    howToOrder: function() {
      var x = document.querySelector("#nav");
      x.className = "";
      x.classList += "how";
    }
  }
};
</script>

<style lang="scss">
.examples {
  transition: 0.3s ease;
  .page-wrap {
    margin: auto;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    .examples-wrap {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 100%;
      @media (max-width: 1024px) {
        justify-content: flex-start;
      }
      .first {
        min-height: 100vh;
        height: 100%;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        @media (max-width: 1024px) {
                  height: auto;
          justify-content: flex-start;
          align-items: flex-start;
        }
        .left {
          width: 50%;
          height: 100%;
          overflow-y: hidden;
          .inner {
            height: 100%;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            align-items: center;
            .steve-image {
              width: 100%;
              height: 100%;
              background-image: url("../assets/img/steve_macbook.png");
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              animation-delay: 1.5s;
            }
          }
        }
        .right {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transform: translateX(0);
          width: 50%;
          height: 100%;
          background-color: #0d7ab6;
          border-bottom-left-radius: 50%;
          color: #fff;
          transition: 0.25s ease-out;
          text-align: left;
          padding: 100px;
          @media (max-width: 1024px) {
            border-bottom-left-radius: 0%;
            padding:100px 20px 50px 20px;
          }
          .inner {
            max-width: 600px;
            margin: auto;
            color: inherit;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            * {
              color: inherit;
            }
            .ani-wrap {
              width: 100%;
              overflow: hidden;
              h1 {
                margin: 0 0 20px 0;
                animation-delay: 1s;
              }
              p {
                margin: 0 0 10px 0;
                animation-delay: 1.25s;
              }
              a {
                animation-delay: 1.5s;
              }
            }
            .buttons {
              text-align: left;
              display: inline-block;
              margin: 10px auto 0 0;
              a {
                animation-delay: 1.5s;
                .default-btn {
                  border-color: #fff;
                  background-color: #fff;
                  color: #0d7ab6;
                }
              }
            }
            .service {
              width: 100%;
              margin: 10px 0 0 0;
              .ani-wrap {
                p {
                  font-size: 26px;
                  margin: 0 0 5px 0;
                  animation-delay: 1s;
                }
              }
            }
          }
        }
        @media (max-width: 1024px) {
          .left,
          .right {
            width: 100%;
            min-height: unset;
            height: auto;
          }
          .left {
            order: 2;
            min-height: 300px;
            .image {
              min-height: 300px;
            }
          }
        }
      }
      .second {
        min-height: 100vh;
        height: 100%;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        @media (max-width: 1024px) {
          justify-content: flex-start;
          align-items: flex-start;
        }
        .left {
          width: 50%;
          height: 100%;
          overflow-y: hidden;
          order: 1;
          .inner {
            height: 100%;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            align-items: center;
            .steve-image {
              width: 100%;
              height: 100%;
              background-image: url("../assets/img/peking_ipad.png");
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              animation-delay: 1.5s;
            }
          }
        }
        .right {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transform: translateX(0);
          width: 50%;
          height: 100%;
          background-color: #2fac66;
          color: #fff;
          transition: 0.25s ease-out;
          text-align: left;
          padding: 100px;
          order: 0;
          border-top-right-radius: 50%;
          @media (max-width: 1024px) {
            border-top-right-radius: 0%;
            padding: 50px 20px;
          }
          .inner {
            max-width: 600px;
            margin: auto;
            color: inherit;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            * {
              color: inherit;
            }
            .ani-wrap {
              width: 100%;
              overflow: hidden;
              h1 {
                margin: 0 0 20px 0;
                animation-delay: 1s;
              }
              p {
                margin: 0 0 10px 0;
                animation-delay: 1.25s;
              }
              a {
                animation-delay: 1.5s;
              }
            }
            .buttons {
              text-align: left;
              display: inline-block;
              margin: 10px auto 0 0;
              a {
                animation-delay: 1.5s;
                .default-btn {
                  border-color: #fff;
                  background-color: #fff;
                  color: #2fac66;
                }
              }
            }
            .service {
              width: 100%;
              margin: 10px 0 0 0;
              .ani-wrap {
                p {
                  font-size: 26px;
                  margin: 0 0 5px 0;
                  animation-delay: 1s;
                }
              }
            }
          }
        }
        @media (max-width: 1024px) {
          .left,
          .right {
            width: 100%;
            min-height: unset;
            height: auto;
          }
          .left {
            min-height: 300px;
            .image {
              min-height: 300px;
            }
          }
        }
      }
    }
  }
}

.examples.page.page-trans-enter-active {
  .page-wrap {
    .examples-wrap {
      .first {
        .right {
          transform: translateX(100%);
        }
      }
      .second {
        .right {
          transform: translateX(-100%);
        }
      }
    }
  }
}

.examples.page.page-trans-leave-active {
  .page-wrap {
    .examples-wrap {
      .first {
        .right {
          transform: translateX(100%);
        }
      }
      .second {
        .right {
          transform: translateX(-100%);
        }
      }
    }
  }
}

.examples.page.page-trans-leave-active {
  .fadeInB {
    animation: fadeOutB 0.25s ease-out both 1;
    animation-delay: 0s !important;
  }
}

.fadeInB {
  animation: fadeInB 0.25s ease-out both 1;
}

.examples.page.page-trans-leave-active {
  .fadeInT {
    animation: fadeOutT 0.25s ease-out both 1;
    animation-delay: 0s !important;
  }
}

.fadeInT {
  animation: fadeInB 0.25s ease-out both 1;
}
</style>
